import React, { useState } from 'react';
import styles from './DropZone.module.css';

function CopyIcon({ data }) {
    const [isCopy, setCopy] = useState(false);

    const copied = () => {
        navigator.clipboard.writeText(data);
        setCopy(true);
        setTimeout(() => {
            setCopy(false);
        }, 2000);
    }
  
    return (
        <i className={`bi px-2 me-2 ${isCopy ? "bi-check2 text-success" : "bi-copy"}`} onClick={copied}>
            {/* <span style={{ "margin-left": "10px"}}>Copy Link</span> */}
        </i>
    );
}

export default CopyIcon;